module.exports = __webpack_public_path__ + "img/Time.85e27e8c.svg";